<template>
  <content-loader v-if="showContentLoader" />
  <div
    ref="contentRef"
    class="page"
  >
    <riseup-header />
    <div ref="iframeContainerRef">
      <iframe
        v-if="htmlContent"
        ref="iframeRef"
        :srcdoc="htmlContent"
        style="width: 100%; border: none;"
        class="html-container"
        sandbox="allow-same-origin allow-popups"
        @load="adjustIframeHeight"
      />
    </div>
    <div class="green-bottom">
      <img src="../../assets/green-bottom-top-2.svg">
      <button
        class="blue-button"
        @click="handleTrialButtonClick"
      >
        Get 3 months at 50% off
      </button>
      <p>
        <b>To unlock the full power of our technology, start your free trial now.</b>
      </p>
      <p>
        With RiseUp, you'll get a complete view of all your accounts, income and spending,
        plus personalised insights and real-time recommendations.
        You also get in-app and community support to help you stay on track.
      </p>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import RiseupHeader from '../Common/RiseupHeader.vue';
import ContentLoader from '../Common/ContentLoader.vue';
import Segment from '../../Segment';
import useContentLoader from '../../composables/useContentLoader';
import { useInsights } from '../../services/insightsService';
import { useOtsJob } from '../../services/otsConfigService';

const { insights, populateInsights } = useInsights();
const contentRef = ref(null);
const route = useRoute();
const iframeRef = ref(null);
const iframeContainerRef = ref(null);
const { getOtsJobConfig } = useOtsJob();

const otsJobConfig = await getOtsJobConfig();

const {
  showContentLoader,
} = useContentLoader();

const handleTrialButtonClick = () => {
  Segment.trackUserInteraction('OtsStartTrialClicked');
  window.location.href = 'https://start.letsriseup.com/?utm_source=ots&coupon=promo_1Px7hrI1mBb8n2B7hP67Vjd0';
};
const htmlContent = ref('');
onMounted(async () => {
  const queryParam = route.query || null;

  if (!insights.value || insights.value.length === 0) {
    await populateInsights(otsJobConfig.jobId);
  }
  htmlContent.value = `
  <!DOCTYPE html>
  <html>
    <head>
      <style>
        body {
          margin: 0;
        }
        body > :first-child {
          padding-bottom: 80px !important; /* Adjust as needed */
        }
      </style>
    </head>
    <body>
      ${insights.value[0]?.html}
    </body>
  </html>
`;

  Segment.trackUserGot('OtsCustomSuccessPageEntered', { fromEmail: queryParam ? queryParam.fromEmail : false, otsJobConfig });

  adjustIframeHeight(); // Initial adjustment
  window.addEventListener('resize', adjustIframeHeight);
});

const adjustIframeHeight = () => {
  if (iframeRef.value && iframeRef.value.contentWindow) {
    setTimeout(() => {
      const iframeDocument = iframeRef.value.contentWindow.document;
      const iframeHeight = iframeDocument.documentElement.scrollHeight || iframeDocument.body.scrollHeight;
      console.log('iframeHeight', iframeHeight);

      iframeContainerRef.value.style.height = `${iframeHeight}px`;
      iframeRef.value.style.height = `${iframeHeight}px`;
    }, 100); // Adjust delay as needed
  }
};

</script>

<style lang="scss" scoped>
@import '../../scss/riseup-vars';

.content {
  margin-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.page {
  background-color: $main_background_color;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.blue-button {
  background-color: #5D7AFD;
  border-radius: 10px;
  height: 48px;
  color: white;
  padding: 10px 20px;
  border: none;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 90%;
  cursor: pointer;
  font-size: 15px;
  font-family: CircularStdBook;
  font-weight: 900;
}

.green-bottom {
  height: 970px;
  width: 100%;
  margin-top: -40px;
  background-color: $green_background_color;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.green-bottom .blue-button {
  height: 64px;
  margin-bottom: 10px;
  box-shadow: 0px 12px 24px rgba(32, 33, 37, 0.12);
}

.green-bottom img {
  margin-top: 60px;
  width: 100%;
  padding-left: 10px;
}

.green-bottom p {
  color: #E8F4BA;
  font-size: 18px;
  font-family: CircularStd;
  line-height: 28px;
  word-wrap: break-word;
  width: 90%;
  margin-top: 43px;
}

.html-container {
  width: 100%;
}

.html-container > :first-child {
  padding-bottom: 60px!important; /* Adjust as needed */
}
</style>
